export function checkCookie(name: string): boolean {
  return document.cookie.split(';').some((c) => {
    return c.trim().startsWith(name + '=')
  })
}

export function deleteCookie(name: string, path = '/', domain = window.location.hostname) {
  if (checkCookie(name)) {
    document.cookie =
      name +
      '=' +
      (path ? ';path=' + path : '') +
      (domain ? ';domain=' + domain : '') +
      ';expires=Thu, 01 Jan 1970 00:00:01 GMT'
  }
}

export function getHasAcceptedCookies(): boolean | null {
  const value = localStorage.getItem('hasAcceptedCookies')

  if (value === 'true') {
    return true
  }

  if (value === 'false') {
    return true
  }

  return null
}

export function setHasAcceptedCookies(value: boolean) {
  localStorage.setItem('hasAcceptedCookies', value ? 'true' : 'false')
}
